import { useFlags, useLDClient } from 'launchdarkly-react-client-sdk';
import { isNil } from 'lodash';
import { useEffect } from 'react';
import { FlagName, Flags, defaultFlags, useLaunchDarklyIdentity } from './shared';

export function useFeatureFlag<T extends FlagName>(flagName: T): Flags[T] {
  const flags = useFlags();

  return flags[flagName] ?? defaultFlags[flagName];
}

export function useInitLaunchDarkly() {
  const ldClient = useLDClient();
  const identity = useLaunchDarklyIdentity();

  useEffect(() => {
    if (isNil(ldClient) || isNil(identity)) {
      return;
    }

    ldClient.identify(identity);
  }, [ldClient, identity]);
}

export * from './shared';
